export default __webpack_public_path__ + "static/media/gabig-banner-fr.61172a88.webp";